import { isDrawableModelLine } from '../crag/useModelLine';
import type { Climb } from '../../types/climb';
import type { ModelCamera, ModelPoint } from '../../types/crag-route';

export interface CragModelFraming {
  key: string;
  view: ModelCamera | null;
  points: ModelPoint[];
  fly: true;
}

interface FramingInput {
  /** The tab: another sector is another place to look at. */
  sectorKey: string;
  sectorView: ModelCamera | null;
  climbs: Climb[];
  selectedClimbId: string | null;
  /**
   * Bumped by every selection and every press of "recentre", so asking for the
   * same place twice goes there twice: the camera may have been turned away since.
   */
  request: number;
  /** A route with no line leaves the camera alone, unless "recentre" says otherwise. */
  recentred: boolean;
}

/**
 * Where the member page's camera should go. Null leaves it where it is.
 *
 * A route: the camera it was saved from, else its line. No route: the sector's saved
 * view, else its lines, else (no view, no points) the whole model.
 */
export function cragModelFraming({
  sectorKey,
  sectorView,
  climbs,
  selectedClimbId,
  request,
  recentred,
}: FramingInput): CragModelFraming | null {
  const key = `${sectorKey}:${selectedClimbId ?? ''}:${request}`;
  const selected = climbs.find((climb) => climb.id === selectedClimbId);

  if (selected && isDrawableModelLine(selected.model_line)) {
    return { key, view: selected.model_line.view ?? null, points: selected.model_line.points, fly: true };
  }
  if (selected && !recentred) return null;

  return {
    key,
    view: sectorView,
    points: climbs.flatMap((climb) => (isDrawableModelLine(climb.model_line) ? climb.model_line.points : [])),
    fly: true,
  };
}
